import React from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loading = () => {
    return (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", mx: 'auto'}}>
            <CircularProgress/>
        </Box>
    );
};

export default Loading;